
import React, { useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useSelector, useDispatch, shallowEqual } from "react-redux";

import {selectedUserSlice} from "../../../../../_redux/selected-user/selectedUserSlice"
import * as handlers from "../../../../../_redux/selected-user/selectedUserHandlers";
import { PARTNERS } from "../../../../../../../util/constants/Partners";


const CreateTradingAccountModal = props => {
  /* Redux State */
  const showCreateAccountModal = useSelector(({selectedUser}) => selectedUser.showCreateAccountModal);
  const [userBasic, status, partners] = useSelector(({selectedUser}) => [selectedUser.data.profile.basic, selectedUser.data.profile?.status, selectedUser.data.profile?.userGroupDetail?.partner ?? []], shallowEqual);
  const [validated, setValidated] = useState(false);
  // Redux dispatch
  const dispatch = useDispatch();
  const {actions: {toggleShowCreateAccountModal}} = selectedUserSlice;

  /* Form submission */
  const handleSubmit = e =>  {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    if (form.checkValidity() === true) {
      const formData = new FormData(form);

      dispatch(handlers.createTradingAccount(props.match.params.userId, {meta: userBasic, ...Object.fromEntries(formData.entries())}));
    }
    setValidated(true);
  }

  const partnerList = PARTNERS.map((partner, i) => <option value={partner.value} key={`partner-${i}`}>
                                                        {partner.name}
                                                    </option>
                                    );
                                    
    
  return (
    <Modal
        show={showCreateAccountModal}
        onHide={_ => dispatch(toggleShowCreateAccountModal())}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false}
        onExited={_ => setValidated(false)}
      >
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
      >
        <Modal.Header >
          <Modal.Title id="contained-modal-title-vcenter">
          <i className="flaticon2-shield text-primary mr-2"></i> {status?.toLowerCase() !== "verified" ? "Trading Accounts are for verified users only" : "Create New Trading Account"}
          </Modal.Title>
          <button type="button" className="close" onClick={_ => dispatch(toggleShowCreateAccountModal())}>
              <span aria-hidden="true" className="d-block">×</span>
              <span className="sr-only">Close</span>
           </button>
        </Modal.Header>
        <Modal.Body>
            <Form.Group controlId="partnerId" className="px-5">
                <Form.Label >Partner</Form.Label>
                <Form.Control
                    required
                    as="select"
                    className="mr-sm-2"
                    custom
                    name="partner"
                >
                    <option value=""></option>
                    {partnerList}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                Select Trading Account Partner
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="name" className="px-5">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              placeholder="Enter name"
              required
            />
            <Form.Control.Feedback type="invalid">
              Name is required
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
            <button
                type="button"
                onClick={_=> dispatch(toggleShowCreateAccountModal())}
                className="btn btn-light btn-elevate px-4"
            >
                Cancel
            </button>
            <> </>
            <button
                type="submit"
                disabled={status?.toLowerCase() !== "verified"}
                className="btn btn-primary btn-elevate px-4 ml-4"
            >
                Create
            </button>
        </Modal.Footer>
    </Form>
      </Modal>

        );
}

export default CreateTradingAccountModal;